import React, { useState } from "react";
import { api } from "@/api";
import { toast } from "sonner";
import { Upload, X, Image as ImgIcon, Video } from "lucide-react";

const initial = {
  nome: "", cognome: "", email: "", telefono: "",
  marca: "", modello: "", anno: "", cambio: "Automatico", km: "",
  targa: "", colore_esterno: "", colore_interno: "", prezzo_desiderato: "", descrizione: "",
};

const VendiAuto = () => {
  const [f, setF] = useState(initial);
  const [fotos, setFotos] = useState([]);   // { path, name }
  const [video, setVideo] = useState(null); // { path, name }
  const [sending, setSending] = useState(false);

  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return r.data.path;
  };

  const onFotos = async (e) => {
    const files = Array.from(e.target.files).slice(0, 10 - fotos.length);
    for (const file of files) {
      try {
        const path = await upload(file);
        setFotos((p) => [...p, { path, name: file.name }]);
      } catch { toast.error(`Errore upload ${file.name}`); }
    }
  };

  const onVideo = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    try { const path = await upload(file); setVideo({ path, name: file.name }); }
    catch { toast.error("Errore upload video"); }
  };

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/valutazione", {
        ...f,
        anno: parseInt(f.anno),
        km: parseInt(f.km),
        prezzo_desiderato: f.prezzo_desiderato ? parseFloat(f.prezzo_desiderato) : null,
        foto_paths: fotos.map((x) => x.path),
        video_path: video?.path || null,
      });
      toast.success("Richiesta inviata! Ti ricontatteremo entro 24h.");
      setF(initial); setFotos([]); setVideo(null);
    } catch (err) { toast.error("Errore invio, riprova"); }
    setSending(false);
  };

  const inp = "w-full bg-[#0B0B0C] border border-white/10 rounded-sm px-3 py-2.5 text-sm text-white focus:border-[#E1BC56] focus:outline-none";
  const lab = "block text-[10px] tracking-widest uppercase text-zinc-500 mb-1.5 font-display";
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <div className="max-w-5xl mx-auto px-6 py-14">
      <div className="mb-10">
        <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-2">VALUTAZIONE GRATUITA</div>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold text-white tracking-widest">VENDI LA TUA AUTO</h1>
        <p className="text-zinc-400 mt-3 max-w-2xl">Compila il form e invia foto/video. Il team di Luigi Cornacchia ti ricontatterà entro 24 ore con una proposta di acquisto trasparente e senza impegno.</p>
      </div>

      <form onSubmit={submit} className="bg-[#121214] border border-white/10 rounded-lg p-6 md:p-10 space-y-8" data-testid="sell-car-form">
        <div>
          <div className="font-display text-sm font-bold tracking-widest text-[#E1BC56] mb-4">DATI PERSONALI</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label className={lab}>Nome *</label><input required className={inp} value={f.nome} onChange={set("nome")} data-testid="sell-nome" /></div>
            <div><label className={lab}>Cognome *</label><input required className={inp} value={f.cognome} onChange={set("cognome")} data-testid="sell-cognome" /></div>
            <div><label className={lab}>Email *</label><input required type="email" className={inp} value={f.email} onChange={set("email")} data-testid="sell-email" /></div>
            <div><label className={lab}>Telefono *</label><input required className={inp} value={f.telefono} onChange={set("telefono")} data-testid="sell-telefono" /></div>
          </div>
        </div>

        <div>
          <div className="font-display text-sm font-bold tracking-widest text-[#E1BC56] mb-4">DATI VEICOLO</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label className={lab}>Marca *</label><input required className={inp} value={f.marca} onChange={set("marca")} data-testid="sell-marca" /></div>
            <div><label className={lab}>Modello *</label><input required className={inp} value={f.modello} onChange={set("modello")} data-testid="sell-modello" /></div>
            <div><label className={lab}>Anno *</label><input required type="number" className={inp} value={f.anno} onChange={set("anno")} data-testid="sell-anno" /></div>
            <div><label className={lab}>Cambio</label>
              <select className={inp} value={f.cambio} onChange={set("cambio")} data-testid="sell-cambio">
                <option>Automatico</option><option>Manuale</option>
              </select>
            </div>
            <div><label className={lab}>Km *</label><input required type="number" className={inp} value={f.km} onChange={set("km")} data-testid="sell-km" /></div>
            <div><label className={lab}>Targa</label><input className={inp} value={f.targa} onChange={set("targa")} data-testid="sell-targa" /></div>
            <div><label className={lab}>Colore Esterno</label><input className={inp} value={f.colore_esterno} onChange={set("colore_esterno")} data-testid="sell-colore-est" /></div>
            <div><label className={lab}>Colore Interno</label><input className={inp} value={f.colore_interno} onChange={set("colore_interno")} data-testid="sell-colore-int" /></div>
            <div className="md:col-span-2"><label className={lab}>Prezzo Desiderato €</label><input type="number" className={inp} value={f.prezzo_desiderato} onChange={set("prezzo_desiderato")} data-testid="sell-prezzo" /></div>
            <div className="md:col-span-2"><label className={lab}>Descrizione</label><textarea rows={4} className={inp} value={f.descrizione} onChange={set("descrizione")} data-testid="sell-descrizione" placeholder="Storico, tagliandi, condizione…" /></div>
          </div>
        </div>

        <div>
          <div className="font-display text-sm font-bold tracking-widest text-[#E1BC56] mb-4">FOTO E VIDEO (max 10 foto + 1 video)</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <label className="border-2 border-dashed border-white/10 rounded-lg p-6 flex flex-col items-center gap-2 cursor-pointer hover:border-[#E1BC56]/50 transition" data-testid="sell-upload-fotos">
              <ImgIcon className="w-6 h-6 text-[#E1BC56]" />
              <span className="text-sm text-zinc-300 tracking-wider">Carica Foto ({fotos.length}/10)</span>
              <input type="file" accept="image/*" multiple className="hidden" onChange={onFotos} disabled={fotos.length >= 10} />
            </label>
            <label className="border-2 border-dashed border-white/10 rounded-lg p-6 flex flex-col items-center gap-2 cursor-pointer hover:border-[#E1BC56]/50 transition" data-testid="sell-upload-video">
              <Video className="w-6 h-6 text-[#E1BC56]" />
              <span className="text-sm text-zinc-300 tracking-wider">{video ? video.name : "Carica Video (1)"}</span>
              <input type="file" accept="video/*" className="hidden" onChange={onVideo} />
            </label>
          </div>
          {fotos.length > 0 && (
            <div className="grid grid-cols-3 md:grid-cols-5 gap-2 mt-4">
              {fotos.map((foto, i) => (
                <div key={foto.path} className="relative border border-white/10 rounded-sm p-2 text-xs text-zinc-400 truncate">
                  {foto.name}
                  <button type="button" onClick={() => setFotos(fotos.filter((_, k) => k !== i))} className="absolute -top-1 -right-1 bg-red-600 rounded-full w-4 h-4 flex items-center justify-center"><X className="w-3 h-3" /></button>
                </div>
              ))}
            </div>
          )}
        </div>

        <button disabled={sending} type="submit" className="cmc-btn-gold w-full py-4 rounded-sm inline-flex items-center justify-center gap-2 text-sm" data-testid="sell-submit">
          <Upload className="w-4 h-4" /> {sending ? "INVIO IN CORSO..." : "INVIA RICHIESTA DI VALUTAZIONE"}
        </button>
      </form>
    </div>
  );
};

export default VendiAuto;
